import { useRoom } from "../../hooks"
import { useNavigate } from "react-router-dom"
import { useProfile } from "src/shared/hooks/useProfile"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import { RoleNames } from "src/shared/hooks/useAuth"
import DetailIcon from "src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon"
import Detail from "src/shared/components/data-display/Detail/Detail"
import DetailContent from "src/shared/components/data-display/Detail/kit/DetailContent/DetailContent"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import DetailAction from "src/shared/components/data-display/Detail/kit/DetailAction/DetailAction"

function IncidenciasItem(): JSX.Element | null {
    const room = useRoom()
    const navigate = useNavigate()
    const { rolName } = useProfile()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    return (
        rolName === RoleNames.roomService || rolName === RoleNames.restaurante
            ? room?.incidencias_activas_usuario
            : room?.incidencias_activas
    ) ? (
        <>
            <Detail>
                <DetailIcon name="alertFill" width={16} height={16} color="var(--orange-warning)" />
                <DetailContent>
                    <DetailRow>
                        <DetailText>
                            Incidencias abiertas
                        </DetailText>
                        <DetailAction onClick={validateIsColabActive(() => navigate(`/u/incidencias-activas/${room?.habitacion_id}`))}>
                            Ver
                        </DetailAction>
                    </DetailRow>
                    <DetailRow>
                        <DetailText>
                            {rolName === RoleNames.roomService || rolName === RoleNames.restaurante
                                ? room?.incidencias_activas_usuario
                                : room?.incidencias_activas}
                        </DetailText>
                    </DetailRow>
                </DetailContent>
            </Detail>
            {InactiveModal}
        </>
    ) : null
}

export default IncidenciasItem
